import {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../app/rp_reducer";
import {setFiltersShown} from "../slices/filters_visibility_slice";
import {SearchFormValuesType} from "../types/SearchFormValuesType";

interface IProps {
    formValues: SearchFormValuesType;
    delayAutoOpen?: boolean;
    onClose?: (makeGtmHit?: boolean) => void;
}

export const useMobileFilters = (props: IProps) => {
    const [isMobileFiltersActive, setMobileFiltersActive] = useState(false);
    const [lastSearchedRegions, setLastSearchedRegions] = useState([]);
    const prevFilterState = useRef<{rooms: unknown; price: unknown; area: unknown; floor_choices: unknown; construction_end_date: unknown} | null>(null);
    const filtersWasShown = useSelector((state: IRPStore) => state.search.filtersVisibility.wasSeen);
    const dispatch = useDispatch();
    const currentPage = useSelector((state: IRPStore) => state.offerList.list.page);
    const {isMobile} = useUserDevice();

    useEffect(() => {
        if (!isMobile) {
            return;
        }

        const roomsFilterInUse = Object.values(props.formValues.rooms).find((el) => el !== "");
        const priceFilterInUse = Object.values(props.formValues.price).find((el) => el !== "");
        const isFirstPage = currentPage === 1;
        const regionsSearched = props.formValues.search?.regions;

        if (
            regionsSearched?.length > 0 &&
            (!roomsFilterInUse || !priceFilterInUse) &&
            (!filtersWasShown || lastSearchedRegions.length !== regionsSearched.length) &&
            isFirstPage &&
            !props.delayAutoOpen
        ) {
            dispatch(setFiltersShown({wasSeen: true}));
            setLastSearchedRegions(regionsSearched);
            setMobileFiltersActive(true);
        }

        if (roomsFilterInUse && priceFilterInUse && !filtersWasShown) {
            dispatch(setFiltersShown({wasSeen: true}));
        }
    }, [props.formValues, filtersWasShown, currentPage, props.delayAutoOpen]);

    const toggleMobileFilterModal = () => {
        setMobileFiltersActive((prev) => {
            if (!prev) {
                prevFilterState.current = {
                    rooms: props.formValues.rooms,
                    price: props.formValues.price,
                    area: props.formValues.area,
                    floor_choices: props.formValues.floor_choices,
                    construction_end_date: props.formValues.construction_end_date
                };
            } else {
                props.onClose?.();
            }

            return !prev;
        });
    };

    const closeMobileFilterModal = (makeGtmHit?: boolean) => {
        setMobileFiltersActive(false);
        prevFilterState.current = null;
        props.onClose?.(makeGtmHit);
    };

    return {
        isMobileFiltersActive,
        toggleMobileFilterModal,
        closeMobileFilterModal,
        prevFilterState
    };
};
import {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../app/rp_reducer";
import {setFiltersShown} from "../slices/filters_visibility_slice";
import {SearchFormValuesType} from "../types/SearchFormValuesType";

interface IProps {
    formValues: SearchFormValuesType;
    delayAutoOpen?: boolean;
    onClose?: (makeGtmHit?: boolean) => void;
}

export const useMobileFilters = (props: IProps) => {
    const [isMobileFiltersActive, setMobileFiltersActive] = useState(false);
    const [lastSearchedRegions, setLastSearchedRegions] = useState([]);
    const prevFilterState = useRef<{rooms: unknown; price: unknown; area: unknown; floor_choices: unknown; construction_end_date: unknown} | null>(null);
    const filtersWasShown = useSelector((state: IRPStore) => state.search.filtersVisibility.wasSeen);
    const dispatch = useDispatch();
    const currentPage = useSelector((state: IRPStore) => state.offerList.list.page);
    const {isMobile} = useUserDevice();

    useEffect(() => {
        if (!isMobile) {
            return;
        }

        const roomsFilterInUse = Object.values(props.formValues.rooms).find((el) => el !== "");
        const priceFilterInUse = Object.values(props.formValues.price).find((el) => el !== "");
        const isFirstPage = currentPage === 1;
        const regionsSearched = props.formValues.search?.regions;

        if (
            regionsSearched?.length > 0 &&
            (!roomsFilterInUse || !priceFilterInUse) &&
            (!filtersWasShown || lastSearchedRegions.length !== regionsSearched.length) &&
            isFirstPage &&
            !props.delayAutoOpen
        ) {
            dispatch(setFiltersShown({wasSeen: true}));
            setLastSearchedRegions(regionsSearched);
            setMobileFiltersActive(true);
        }

        if (roomsFilterInUse && priceFilterInUse && !filtersWasShown) {
            dispatch(setFiltersShown({wasSeen: true}));
        }
    }, [props.formValues, filtersWasShown, currentPage, props.delayAutoOpen]);

    const toggleMobileFilterModal = () => {
        setMobileFiltersActive((prev) => {
            if (!prev) {
                prevFilterState.current = {
                    rooms: props.formValues.rooms,
                    price: props.formValues.price,
                    area: props.formValues.area,
                    floor_choices: props.formValues.floor_choices,
                    construction_end_date: props.formValues.construction_end_date
                };
            } else {
                props.onClose?.();
            }

            return !prev;
        });
    };

    const closeMobileFilterModal = (makeGtmHit?: boolean) => {
        setMobileFiltersActive(false);
        prevFilterState.current = null;
        props.onClose?.(makeGtmHit);
    };

    return {
        isMobileFiltersActive,
        toggleMobileFilterModal,
        closeMobileFilterModal,
        prevFilterState
    };
};
